export enum RoomType {
  LOBBY = 'lobby',
  PUBLIC = 'wigginOffice',
  CUSTOM = 'custom',
  /** A platform admin's room for painting one map's VRs (SC-422). Not listed. */
  MAP_EDITOR = 'map_editor',
}

export interface IRoomData {
  name: string
  description: string
  password: string | null
  autoDispose: boolean
  // Optional properties for default rooms
  isDefaultRoom?: boolean
  roomType?: RoomType
  customRoomId?: string
  companyId?: string | null // null means global/public room, string means company-specific
  // Creator information
  creatorId?: string
  playerName?: string // Used to store creator name
  /** Set by the server on rooms it starts; `Wiggin.onCreate` refuses a company room without it (SC-422). */
  serverCreateToken?: string
  // Room metadata
  metadata?: {
    name: string
    description: string
    hasPassword: boolean
    isPrivate?: boolean
    passwordProtected?: boolean
    persistent?: boolean
    creatorId?: string
    playerName?: string
    roomType: RoomType
    /** Legacy: the public rooms still set it; company rooms use `persistent` (SC-422). */
    isDefaultRoom?: boolean
    keepAlive?: boolean
    priority?: number
    creatorName?: string
    mapId?: string
    spawnPoint?: { x: number; y: number }
    companyId?: string | null // Company ID for multi-tenant support
    isCompanyLobby?: boolean
    company_name?: string
    company_subdomain?: string
    customRoomId?: string
    maxClients?: number
    /** The company's lobby (`ColyseusRoom.isLobby`, SC-422). */
    isLobby?: boolean
    /** Seat joining players on a free chair, from the map's settings. */
    autoSeatOnJoin?: boolean
    /** A platform admin's room for painting the map's VRs (`map_editor_<mapId>`). */
    isMapEditorRoom?: boolean
    /** `Map.vrRevision` this room loaded; older than the map's means it needs a restart. */
    vrRevision?: number
  }
}
